import {i18n} from 'src/shared/config'

export const segments = {
  [i18n('profile.form.segment.options.auto_products', 'Автотовары')]:
    'auto_products',
  [i18n(
    'profile.form.segment.options.ready_meals_and_cooking',
    'Готовые блюда и кулинария',
  )]: 'ready_meals_and_cooking',
  [i18n('profile.form.segment.options.children_goods', 'Детские товары')]:
    'children_goods',
  [i18n('profile.form.segment.options.documents', 'Документы')]: 'documents',
  [i18n(
    'profile.form.segment.options.cosmetics_and_perfumes',
    'Косметика и парфюмерия',
  )]: 'cosmetics_and_perfumes',
  [i18n('profile.form.segment.options.furniture', 'Мебель')]: 'furniture',
  [i18n('profile.form.segment.options.medical_products', 'Медицинские товары')]:
    'medical_products',
  [i18n(
    'profile.form.segment.options.clothing_and_accessories',
    'Одежда и аксессуары',
  )]: 'clothing_and_accessories',
  [i18n('profile.form.segment.options.sporting_products', 'Спорттовары')]:
    'sporting_products',
  [i18n(
    'profile.form.segment.options.construction_products',
    'Строительные товары',
  )]: 'construction_products',
  [i18n('profile.form.segment.options.household_goods', 'Товары для дома')]:
    'household_goods',
  [i18n(
    'profile.form.segment.options.leisure_and_hobby_products',
    'Товары для досуга и хобби',
  )]: 'leisure_and_hobby_products',
  [i18n('profile.form.segment.options.pet_supplies', 'Товары для животных')]:
    'pet_supplies',
  [i18n(
    'profile.form.segment.options.goods_for_holidays',
    'Товары для праздника',
  )]: 'goods_for_holidays',
  [i18n(
    'profile.form.segment.options.everyday_products',
    'Товары повседневного спроса (продукты питания, напитки, бытовая химия)',
  )]: 'everyday_products',
  [i18n('profile.form.segment.options.flowers', 'Цветы')]: 'flowers',
  [i18n(
    'profile.form.segment.options.electronics_and_household_appliances',
    'Электроника и бытовая техника',
  )]: 'electronics_and_household_appliances',
  [i18n('profile.form.segment.options.other', 'Другие товары')]: 'other',
} as const
